export default __webpack_public_path__ + "static/media/team-illustration-2.a38d7c91.svg";